<template>
  <div
    class="tw-justify-between tw-items-center"
    :class="[desktopOnly ? 'lg:tw-flex tw-hidden' : 'tw-flex']"
  >
    <div class="tw-w-full tw-flex tw-justify-start">
      <div class="tw-text-xs">{{ currentDay }}</div>
      <span class="tw-text-xs tw-font-bold tw-ml-11">
        {{ departureField }}
      </span>
    </div>

    <div class="tw-w-full tw-flex tw-justify-end tw-items-center">
      <div v-if="!isSeaDay" class="tw-text-xs tw-px-3">
        <span>{{ arrivalData }}</span>
        <span v-if="arrivalTimeExists && departureTimeExists"> | </span>
        <span>{{ departureData }}</span>
      </div>

      <CruiseItineraryNavigation
        v-if="showSlidesNavigationArrows"
        :cruise-index="cruiseIndex"
        :items-length="itemsLength"
      />
    </div>
  </div>
</template>

<script>
import CruiseItineraryNavigation from "@/stories/Components/CruiseItineraryDetail/Elements/desktop/CruiseItineraryNavigation/CruiseItineraryNavigation.vue";
import TimeMixin from "@/stories/Components/CruiseItineraryDetail/Mixins/TimeMixin.js";
import TimeConverter from "@/mixins/TimeConverter";

export default {
  name: "CruiseItineraryInfo",
  components: { CruiseItineraryNavigation },
  mixins: [TimeMixin, TimeConverter],
  props: {
    cruiseIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    textLabels: {
      type: Object,
      required: true,
      default: () => {},
    },
    arrivalTime: {
      type: String,
      required: true,
      default: "",
    },
    departureTime: {
      type: String,
      required: true,
      default: "",
    },
    destinationName: {
      type: String,
      required: true,
      default: "",
    },
    itemsLength: {
      type: Number,
      required: true,
      default: 1,
    },
    desktopOnly: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSeaDay: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    currentDay() {
      const { cruiseItineraryDayLabel } = this.textLabels;
      return `${cruiseItineraryDayLabel} ${this.cruiseIndex + 1}`;
    },
    arrivalTimeExists() {
      return this.isValidTime(this.arrivalTime);
    },
    arrivalData() {
      const { cruiseItineraryMapArrivesAtLabel } = this.textLabels;

      return this.arrivalTimeExists
        ? `${cruiseItineraryMapArrivesAtLabel} ${this.getNonMilitaryTime(
            this.arrivalTime,
            true
          )}`
        : "";
    },
    departureTimeExists() {
      return this.isValidTime(this.departureTime);
    },
    departureData() {
      const { cruiseItineraryMapDepartsAtLabel } = this.textLabels;
      return this.departureTimeExists
        ? `${cruiseItineraryMapDepartsAtLabel} ${this.getNonMilitaryTime(
            this.departureTime,
            true
          )}`
        : "";
    },
    departureField() {
      return this.destinationName;
    },
    showSlidesNavigationArrows() {
      return this.itemsLength > 1;
    },
  },
};
</script>
